module.exports = __webpack_public_path__ + "img/douyin.1428f7a7.svg";